import React from "react";
import Container from "../Container/Container";
import { Link } from "react-router-dom";
import classes from "./NextPage.module.css";

const NextPage = (props) => {
  return (
    <div className={classes.NextPage}>
      <Container>
        <Link to={props.link}>
          {props.title}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="156.381"
            height="70.816"
            viewBox="0 0 156.381 70.816"
          >
            <defs></defs>
            <path
              className={classes.TripleArrow}
              d="M121.63,0l34.752,34.721L121,70.816Zm-61,0L95.381,34.721,60,70.816ZM.63,0,35.381,34.721,0,70.816Z"
            />
          </svg>
          {/* <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="long-arrow-alt-right"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            data-v-2389d0d5=""
          >
            <path
              fill="currentColor"
              d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
              data-v-2389d0d5=""
            ></path>
          </svg> */}
        </Link>
      </Container>
    </div>
  );
};

export default NextPage;
